import {
  Box,
  Code,
  Heading,
  Link,
  Text,
  Em,
  Container,
} from "@chakra-ui/react";
import { LuTwitter } from "react-icons/lu";

export function About() {
  return (
    <Container colorPalette="orange">
      <Heading as="h3" size="2xl" mb={4}>
        About
      </Heading>
      <Text fontSize="lg" my={4}>
        Hi! My name is <Link href="https://diwaker.io/">Diwaker</Link> (
        <Link href="https://x.com/diwakergupta">
          <LuTwitter />
        </Link>
        ) and I <Em>love</Em> the podcast{" "}
        <Link href="https://seenunseen.in/">The Seen and the Unseen</Link>
        (TSATU). In each episode, host{" "}
        <Link href="https://amitvarma.com/">Amit Varma</Link> asks his guests to
        recommend books, music, movies etc and I've discovered some amazing
        stuff through these (as the many unread books in my bookshelf will
        attest!).{" "}
      </Text>
      <Text fontSize="lg" my={4}>
        This is my small attempt to make these recommendations more
        discoverable, and even if one person becomes a TSATU listener in the
        process, I'd consider that success!
      </Text>
      <Text fontSize="lg" my={4}>
        Check out{" "}
        <Link href="https://diwaker.io/building-tsatu-rocks/">this post</Link>{" "}
        on how I built this site! In the meantime, if you have any feedback
        (positive or otherwise), drop me a note at <Code size="lg">hi@</Code>{" "}
        this domain or HMU on X!
      </Text>
    </Container>
  );
}
